"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentService = void 0;
const service_1 = require("@phishtool/service");
const get_homepage_content_1 = __importDefault(require("~controllers/service/content/get-homepage-content"));
class ContentService extends service_1.Service {
    constructor() {
        super(...arguments);
        this.useGetHomepageContent = this.addCollectionNonResourceQuery({
            routeId: 'home',
            controller: get_homepage_content_1.default,
            middleware: [],
            opts: {
                staleTime: Infinity,
            },
        });
    }
}
exports.ContentService = ContentService;
